<template>
	<div>
		<v-container fluid pa-0>
			<v-card elevation="0">
				<v-container fluid grid-list-xl class="toolbar-container">
					<v-layout row wrap :class="$bp.smallScreen ? 'mx-0' : null">
						<v-toolbar color="grey lighten-3" elevation="1">
							<bc-btn-back></bc-btn-back>
							<v-toolbar-title class="ml-0">{{ $t($route.meta.title) }}</v-toolbar-title>
							<v-spacer></v-spacer>
							<bc-btn-add v-if="hasPerm('tags.create')" @invoke-method="invokeMethod($event)" action="openTagForm"></bc-btn-add>
							<bc-btn-refresh @invoke-method="dbGetTags(true)"></bc-btn-refresh>
							<bc-search-menu :params="axiosParams">
								<v-list>
									<v-list-tile class="mb-3">
										<bc-search-input v-model="filter.search" :params="axiosParams"></bc-search-input>
									</v-list-tile>
									<v-list-tile v-if="isInternalUser() || hasLoginType('d_acct_mgr', 'distributor')">
										<bc-autocomplete
											v-model="filter.company_id"
											:label="`${$t('lang.company')}`"
											:items="customer_options"
											item-value="company_id"
											item-text="company"
											prepend-icon="business"
										></bc-autocomplete>
									</v-list-tile>
								</v-list>
							</bc-search-menu>
							<bc-btn-mobile-nav @invoke-method="invokeMethod($event)" :mobile-list="mobile_list"></bc-btn-mobile-nav>
						</v-toolbar>
					</v-layout>
				</v-container>
				<bc-circle-loader v-if="loading == true"></bc-circle-loader>
				<v-card-text v-else :class="$bp.smallScreen ? 'pa-0' : null">
					<v-data-table :headers="headers" :items="tags" :no-data-text="$t('lang.no_results_matching')" hide-actions>
						<template slot="items" slot-scope="props">
							<tr class="clickable" @mouseup.left="openTagForm(props.item)">
								<td>{{ props.item.tag }}</td>
								<td class="text-center">{{ props.item.device_count }}</td>
								<td>{{ props.item.company }}</td>
							</tr>
						</template>
					</v-data-table>
					<bc-pagination :page="page" :params="axiosParams" name="tags"></bc-pagination>
				</v-card-text>
			</v-card>

			<bc-dialog :value="tag_dialog">
				<v-card>
					<v-form ref="form_tag">
						<v-card-title>
							<span class="headline">{{ tag.tag_id ? $t("lang.edit_tag") : $t("lang.add_tag") }}</span>
							<v-spacer></v-spacer>
							<bc-btn-dialog-close
								@invoke-method="invokeMethod($event)"
								action="closeTagDialog"
								:dialog-status="tag_dialog"
							></bc-btn-dialog-close>
						</v-card-title>
						<v-card-text>
							<v-container grid-list-form>
								<v-layout row wrap>
									<v-flex xs12>
										<v-text-field
											v-focus="tag_dialog"
											v-model="tag.tag"
											:label="`${$t('lang.tag')} *`"
											:counter="showCounter(tag.tag, 'tags.tag')"
											:rules="ifValid('tags.tag')"
										></v-text-field>
									</v-flex>
									<v-flex xs12>
										<bc-autocomplete
											v-model="tag.company_id"
											:label="`${$t('lang.company')} *`"
											:items="customer_options"
											item-value="company_id"
											item-text="company"
											:rules="ifValid('tags.company_id')"
										></bc-autocomplete>
									</v-flex>
								</v-layout>
							</v-container>
						</v-card-text>
						<v-card-actions>
							<v-btn v-if="hasPerm('tags.delete') && tag.tag_id" color="error" @mouseup.left="$refs.delete_tags.openDialog()">{{
								$t("lang.delete")
							}}</v-btn>
							<v-spacer></v-spacer>
							<v-btn flat @mouseup.left="closeTagDialog()">{{ $t("lang.cancel") }}</v-btn>
							<v-btn v-if="hasPerm('tags.update')" color="success" @click="saveTags">{{ $t("lang.save") }}</v-btn>
						</v-card-actions>
					</v-form>
				</v-card>
			</bc-dialog>
			<delete-confirmation-dialog
				ref="delete_tags"
				:heading="$t('lang.delete_tag')"
				:message="$t('lang.confirm_delete_message')"
				@onConfirm="deleteTags(tag.tag_id)"
			></delete-confirmation-dialog>
		</v-container>
	</div>
</template>

<script>
import { mapGetters, mapState, mapActions, mapMutations } from "vuex";
import { store } from "Store/store";
import _ from "lodash";

export default {
	data() {
		return {
			mobile_list: [
				{ title: this.$t("lang.add_new"), action: "openTagForm" },
				{ title: this.$t("lang.refresh"), action: "dbGetTags", params: [true] },
			],
			headers: [
				{ text: this.$t("lang.tag"), sortable: false, width: "50%" },
				{ text: this.$t("lang.device_count"), align: "center", sortable: false, width: "20%" },
				{ text: this.$t("lang.company"), sortable: false, width: "30%" },
			],
			enableAddModal: true,
			enableEditModal: true,
			tag: {},
			filter: {
				search: "",
				status: "1",
				company_id: "",
			},
			tag_dialog: false,
			dbGetTags: _.debounce(this.getTags, 1500, { maxWait: 1500, leading: true, trailing: false }),
			loading: true,
		};
	},
	beforeRouteEnter(to, from, next) {
		next((vm) => {
			vm.loading = true;
			_.delay(() => {
				let parsedQuery = JSON.parse(JSON.stringify(to.query));
				store
					.dispatch("fetchTags", {
						body: parsedQuery,
					})
					.then((data) => {
						if (typeof data !== "undefined" && data.tags) {
							vm.setQuery(parsedQuery, vm.filter, vm.default_filter);
							vm.finishLoader();
							vm.loading = false;
						} else {
							next({ name: "dashboard", replace: true });
						}
					});
			}, 500);
		});
	},
	beforeRouteUpdate(to, from, next) {
		this.loading = true;
		let parsedQuery = JSON.parse(JSON.stringify(to.query));
		_.delay(() => {
			this.fetchTags({
				body: parsedQuery,
			}).then((data) => {
				if (typeof data !== "undefined" && data.tags) {
					this.setQuery(parsedQuery, this.filter, this.default_filter);
					this.finishLoader();
					this.loading = false;
					next();
				} else {
					next({ name: "dashboard", replace: true });
				}
			});
		}, 500);
	},
	computed: {
		...mapState({
			default_filter: (state) => state.tags.tags_filter,
			page: (state) => state.tags.page,
			rules_tags: (state) => state.tags.rules_tags,
			tag_status_options: (state) => state.settings.tag_status_options,
			tags: (state) => state.tags.tags,
			customer_options: (state) => state.customers.customer_options,
		}),
		axiosParams() {
			return this.prepareParams(this.filter, this.default_filter);
		},
	},
	methods: {
		...mapActions(["fetchTags", "saveTag", "deleteTag", "fetchCustomers"]),
		...mapMutations(["validationOn", "validationOff", "toggleGlobalSnackbar", "toggleModalLoader"]),
		openTagForm(item = null) {
			if (item != null) {
				if (this.enableEditModal) {
					if (this.$refs.form_tag) item ? this.$refs.form_tag.resetValidation() : this.$refs.form_tag.reset();

					this.$nextTick(() => {
						this.tag = item != null ? this.assignObj2(item, this.rules_tags) : {};
						this.tag_dialog = true;
					});
				} else {
					this.$router.push({ name: "tag", params: { id: item.tag_id } });
				}
			} else {
				if (this.enableAddModal) {
					if (this.$refs.form_tag) item ? this.$refs.form_tag.resetValidation() : this.$refs.form_tag.reset();
					this.tag_dialog = true;
				} else {
					this.$router.push({ name: "tag" });
				}
			}
		},
		saveTags() {
			this.validationOn();
			this.$nextTick(() => {
				if (this.validateForm("form_tag")) {
					let body = this.prepForm(this.tag, this.rules_tags);
					if (this.tag.tag_id) body.tag_id = this.tag.tag_id;

					this.saveTag({
						body: body,
					}).then((data) => {
						if (data && data.code == "200") {
							if (this.enableEditModal) {
								this.getTags();
								this.closeTagDialog();
								this.tag = {};
							} else {
								this.$router.push({ name: "tag", params: { id: data.tag_id } });
							}
						} else {
							//this.toggleModalLoader(false);
						}
					});
				}
			});
		},
		deleteTags(id = null) {
			this.deleteTag({
				id: id,
			}).then((data) => {
				if (data && data.code == "200") {
					this.getTags();
					this.closeTagDialog();
				} else {
					this.toggleModalLoader(false);
				}
			});
		},

		closeTagDialog() {
			this.tag_dialog = false;
			this.$refs.delete_tags.close();
			this.validationOff();
			this.toggleModalLoader(false);
		},
		getTags(pg_refresh = false) {
			this.startLoader();
			this.loading = true;
			this.fetchTags({
				body: JSON.parse(JSON.stringify(this.$route.query)),
			})
				.then((data) => {
					if (typeof data === "undefined") this.$router.push({ name: "dashboard" });
				})
				.finally(() => {
					this.tag_dialog = false;
					this.toggleModalLoader(false);
					this.validationOff();
					this.finishLoader(pg_refresh);
					this.loading = false;
				});
		},
	},
	mounted() {
		if (this.customer_options.length == 0) this.fetchCustomers({ body: { options: 1 } });
	},
};
</script>
